import React from 'react';
import { BsGithub } from 'react-icons/bs';
import { SiCodechef, SiCodeforces } from 'react-icons/si'

const SocialMedia = () => (
  <div className="app__social">
    <div>
      <a href="https://github.com/VISHAL-KUMAR786">
        <BsGithub />
      </a>
    </div>
    <div>
      <a href="https://www.codechef.com/users/bakru_k78">
        <SiCodechef />
      </a>
    </div>
    <div>
      <a href="https://codeforces.com/profile/vishal_k78">
        <SiCodeforces />
      </a>
    </div>
  </div>
);

export default SocialMedia;